// extracted by mini-css-extract-plugin
module.exports = {"loader":"ModalLoader_loader__3DqbH"};